import { useRef, useEffect } from "react";

const useEffectWithoutFirstRender = (callback, dependencies) => {
    const firstMount = useRef(true);

    useEffect(() => {
        if (!firstMount.current) callback();
        else firstMount.current = false;
    }, dependencies);
};

export default useEffectWithoutFirstRender;
